import { attachPollResultsKey } from '@dmp/qqms/data-access';
import { isQuestion } from '@dmp/qqms/survey-utils';
import type { Survey } from '@dmp/qqms/types';
import { truthy } from '@dmp/shared/helpers';
import { isPollResultCardItem } from '../state-type-guards';
import type { StoreState } from '../state-types';
import { buildCardConfig } from './build-card-config';

/**
 * [Expensive calculation] Build Survey Config from ALL State. USE THIS CAUTIOUSLY.
 */
export const buildSurveyConfig = (state: StoreState): Survey => {
    const survey = state.survey;
    const cards = Object.values(state.cards);

    // attach poll results to cards
    const cardConfigs = survey.cardIds
        .map((cardId) => {
            const card = state.actions.getCard(cardId);
            const cardConfig = buildCardConfig(card);
            if (!cardConfig) {
                return undefined;
            }

            const hasPollResults = cards.some(
                (c) => isPollResultCardItem(c) && c.questionId === cardConfig.id
            );

            if (isQuestion(cardConfig) && hasPollResults) {
                return attachPollResultsKey(cardConfig);
            }

            return cardConfig;
        })
        .filter(truthy);

    return {
        ...survey,
        versionId: 'tbd',
        cards: cardConfigs,
    };
};
